import { c as _c } from "react/compiler-runtime";
import * as React from 'react';
import Box from '@mui/material/Box';
import type { VehicleSpecsTab } from '@/components/Vehilces/VehicleSpecsTabs/VehicleSpecsTabSelector';
interface TabPanelProps {
  children?: React.ReactNode;
  name: VehicleSpecsTab;
  value: VehicleSpecsTab;
}
export function VehicleSpecsTabPanel(t0) {
  const $ = _c(15);
  let children;
  let name;
  let props;
  let value;
  if ($[0] !== t0) {
    ({
      children,
      value,
      name,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = children;
    $[2] = name;
    $[3] = props;
    $[4] = value;
  } else {
    children = $[1];
    name = $[2];
    props = $[3];
    value = $[4];
  }
  const t1 = value !== name;
  const t2 = `vehicle-tab-panel-${name}`;
  const t3 = `vehicle-tabs-${name}`;
  let t4;
  if ($[5] !== children || $[6] !== name || $[7] !== value) {
    t4 = value === name && <Box sx={{
      p: 3
    }}>{children}</Box>;
    $[5] = children;
    $[6] = name;
    $[7] = value;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  let t5;
  if ($[9] !== props || $[10] !== t1 || $[11] !== t2 || $[12] !== t3 || $[13] !== t4) {
    t5 = <div role="tabpanel" hidden={t1} id={t2} aria-labelledby={t3} {...props}>{t4}</div>;
    $[9] = props;
    $[10] = t1;
    $[11] = t2;
    $[12] = t3;
    $[13] = t4;
    $[14] = t5;
  } else {
    t5 = $[14];
  }
  return t5;
}